import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private _authService: AuthenticationService) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const skipAuthentication: boolean = req.headers.has("skipAuthorization");

		if (skipAuthentication) {
			req.headers.delete("skipAuthorization");
			return next.handle(req);
		} else {
			const cloned = req.clone({
				withCredentials: true,
			});
			return next.handle(cloned);
		}
	}
}
